import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/resource/annualReport.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const AnnualReport = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Annual Report`;
  }, []);

  const shareUrl = "https://ashroyangon.org/resources/annual-report";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="annual_report_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Annual Report</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        {/* Annual Report Part */}
        <div className="annual_report_wrapper">
          <div className="container">
            <h2>Annual Report</h2>
            <div className="content_wrapper">
              <div className="container">
                <div className="report_wrapper">
                  <div className="report">
                    <p> Annual Report 2025</p>
                    <a
                      href="/annual-report-2025.pdf"
                      // download={"Annual Report 2025.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf</span>
                    </a>
                  </div>
                  <div className="report mt-3">
                    <p> Annual Report 2024 </p>
                    <a
                      href="/annual-report-2024.pdf"
                      // download={"Annual Report 2024.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf </span>
                    </a>
                  </div>
                  <div className="report mt-3">
                    <p> Annual Report 2023</p>
                    <a
                      href="/annual-report-2023.pdf"
                      // download={"Annual Report 2023.pdf"}
                      target={"_blank"}
                      id="style-2"
                      data-replace="Download Pdf"
                    >
                      <span> Download Pdf </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AnnualReport;
